import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { createRequestOption } from '../app/shared/util/request-util';
import { ILLEGAL_INVOCATION } from '../app/shared/util/security-util';
import { TransporterConfigurationService } from './transporter-configuration.service';
import { ITransporterConfiguration } from '../models/transporter-configuration.model';

export type EntityResponseType = HttpResponse<ITransporterConfiguration>;
export type EntityArrayResponseType = HttpResponse<ITransporterConfiguration[]>;

@Injectable({ providedIn: 'root' })
export class TransporterConfigurationExtendedService extends TransporterConfigurationService {
  private transporterConfigurationUrl = '/transporter-configuration';

  override create(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override update(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override partialUpdate(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override find(): Observable<EntityResponseType> {
    throw ILLEGAL_INVOCATION;
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<ITransporterConfiguration[]>(this.transporterConfigurationUrl, {
      params: options,
      observe: 'response',
    });
  }

  override delete(): Observable<HttpResponse<{}>> {
    throw ILLEGAL_INVOCATION;
  }

  override addTransporterConfigurationToCollectionIfMissing(
    transporterConfigurationCollection: ITransporterConfiguration[],
    ...transporterConfigurationsToCheck: any[]
  ): ITransporterConfiguration[] {
    return super.addTransporterConfigurationToCollectionIfMissing(transporterConfigurationCollection, ...transporterConfigurationsToCheck);
  }
}
